




export const builderHeading = "Apply Concepts To Real-World Situations";
export const builderSubtitle =
"Generate real-world tasks that help students apply what they learn";

export const topicLabel = "WHAT IS THE TASK TOPIC?";
export const topicPlaceholder =
"e.g., Budgeting, Urban Planning, or Sustainable Energy";

export const difficultyLabel = "DIFFICULTY LEVEL";
export const generateLabel = "Generate Real-World Tasks";
export const generateHint =
  "Creates classroom-ready tasks that connect learning to real life";
export const generatingMessage = "Connecting your topic to real-world tasks…";

export const resultsHeading = "SELECT A PROJECT IDEA TO EXPAND";
export const resultsSubheading =
"CHOOSE A CLASSROOM-READY TASK ALIGNED TO YOUR TOPIC";
export const newTopicLabel = "NEW TOPIC";

export const difficultyOptions =


[
{ id: "EASY", label: "EASY" },
{ id: "BALANCED", label: "BALANCED" },
{ id: "CHALLENGING", label: "CHALLENGING" }];


export const difficultyStyles =


{
  EASY: { bg: "bg-[#dcfce7]", text: "text-[#166534]" },
  BALANCED: { bg: "bg-[#dbe1ff]", text: "text-[#00174b]" },
  CHALLENGING: { bg: "bg-[#fee2e2]", text: "text-[#991b1b]" }
};

export const defaultRealWorldTaskBuilderConfig = {
  topicText: "",
  difficulty: "BALANCED"
};